/**
 * Shared constants for Slate-Velt Comments integration
 *
 * This module contains all magic strings and configuration constants
 * used across the application.
 */
export const Constants = {
    /**
     * DOM attribute names used for editor identification and location tracking.
     */
    ATTRIBUTES: {
        EDITOR_ID: 'data-editor-id',
        LOCATION_ID: 'data-velt-location-id',
        ANNOTATION_ID: 'annotation-id',
        MULTI_THREAD_ANNOTATION_ID: 'multi-thread-annotation-id',
    },
    /**
     * Element types used in the editor's document model.
     */
    ELEMENT_TYPE: {
        VELT_COMMENT: 'veltComment',
    },
    /**
     * Mark/extension name constant.
     * Generic constant name, value is Slate-specific for this package.
     */
    MARK_NAME: 'veltComment',
    /**
     * Storage key constant.
     * Generic constant name, value is Slate-specific for this package.
     */
    STORAGE_KEY: 'slateVeltComments',
    /**
     * Default extension name for error messages.
     */
    DEFAULT_EXTENSION_NAME: 'VeltComments',
    /**
     * Default editor ID used when no editor ID is provided.
     * Uses '__default__' to avoid collision with user-provided values.
     */
    DEFAULT_EDITOR_ID: '__default__',
    /**
     * Terminal status type for resolved/closed comments.
     */
    STATUS_TERMINAL: 'terminal',
    /**
     * Log prefix for console messages.
     */
    LOG_PREFIX: 'SlateVeltComments: ',
    /**
     * Session storage key for debug mode.
     */
    DEBUG_MODE_KEY: 'debugMode',
    /**
     * Session storage key for forced debug mode.
     */
    FORCE_DEBUG_MODE_KEY: 'forceDebugMode',
};
